import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_FriedParagraph = _resolveComponent("FriedParagraph");
    const _component_FriedH2 = _resolveComponent("FriedH2");
    const _component_FriedLink = _resolveComponent("FriedLink");
    const _component_i18n_t = _resolveComponent("i18n-t");
    const _component_FriedMessage = _resolveComponent("FriedMessage");
    const _component_VerifyUserForm = _resolveComponent("VerifyUserForm");
    const _component_LoginSignupContainer = _resolveComponent("LoginSignupContainer");
    return (_openBlock(), _createBlock(_component_LoginSignupContainer, null, {
        default: _withCtx(() => [
            _createElementVNode("div", null, [
                _createVNode(_component_FriedParagraph, { class: "branding" }, {
                    default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('create-account')), 1)
                    ]),
                    _: 1
                }),
                _createVNode(_component_FriedH2, { class: "verify-user-title branding" }, {
                    default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('welcome-to-getaccept')), 1)
                    ]),
                    _: 1
                }),
                (_ctx.error)
                    ? (_openBlock(), _createBlock(_component_FriedMessage, {
                        key: 0,
                        class: "error",
                        title: _ctx.$t(_ctx.error.title),
                        type: _ctx.MessageType.Error
                    }, {
                        default: _withCtx(() => [
                            _createVNode(_component_i18n_t, {
                                keypath: _ctx.error.description
                            }, {
                                contactSupportLink: _withCtx(() => [
                                    _createVNode(_component_FriedLink, {
                                        normal: true,
                                        href: "http://help.getaccept.com/",
                                        target: "_blank"
                                    }, {
                                        default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.$t('contact-support')), 1)
                                        ]),
                                        _: 1
                                    })
                                ]),
                                _: 1
                            }, 8, ["keypath"])
                        ]),
                        _: 1
                    }, 8, ["title", "type"]))
                    : _createCommentVNode("", true),
                _createVNode(_component_VerifyUserForm, {
                    loading: _ctx.loading,
                    "default-language": _ctx.languageStore.language,
                    "default-first-name": _ctx.firstName,
                    "default-last-name": _ctx.lastName,
                    "is-invitation": _ctx.isInvitation,
                    onLanguageChange: _ctx.handleLanguageChange,
                    onSubmit: _ctx.handleSubmit
                }, null, 8, ["loading", "default-language", "default-first-name", "default-last-name", "is-invitation", "onLanguageChange", "onSubmit"]),
                _createVNode(_component_FriedParagraph, { class: "sign-in-link" }, {
                    default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('already-have-an-account')) + " ", 1),
                        _createVNode(_component_FriedLink, {
                            href: "/",
                            class: "bold"
                        }, {
                            default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t('sign-in')), 1)
                            ]),
                            _: 1
                        })
                    ]),
                    _: 1
                })
            ])
        ]),
        _: 1
    }));
}
